var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneysRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "red",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M33.775 13.86v9.013c0 5.39-3.08 7.7-7.7 7.7H10.692c-.787 0-1.54-.07-2.24-.228a7 7 0 0 1-1.242-.332c-2.625-.98-4.218-3.255-4.218-7.14V13.86c0-5.39 3.08-7.7 7.7-7.7h15.383c3.92 0 6.737 1.663 7.49 5.46.122.7.21 1.418.21 2.24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "red",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M39.026 19.11v9.013c0 5.39-3.08 7.7-7.7 7.7H15.943c-1.295 0-2.467-.175-3.482-.56-2.083-.77-3.5-2.363-4.008-4.918.7.158 1.453.228 2.24.228h15.383c4.62 0 7.7-2.31 7.7-7.7V13.86c0-.822-.07-1.557-.21-2.24 3.325.7 5.46 3.045 5.46 7.49"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "red",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M18.37 22.995a4.62 4.62 0 1 0 0-9.24 4.62 4.62 0 0 0 0 9.24M8.363 14.525v7.7M28.387 14.525v7.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneysRed);
export default __webpack_public_path__ + "static/media/moneysRed.ebb3200051e09a850cb1df6554c61ed9.svg";
export { ForwardRef as ReactComponent };